



















import { Component, Prop, Vue } from 'vue-property-decorator'

import { Action } from 'vuex-class'

import { Item, ItemResourcePayload, ModalState } from '@/models'

import ItemForm from './ItemForm.vue'

@Component({
  components: {
    ItemForm
  }
})
export default class CreateItemModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  data: ItemResourcePayload | null = null
  isValid = false

  @Action('menu/createItem')
  createItem!: (payload: ItemResourcePayload) => Promise<Item>

  cancel () {
    this.modalState.reset()

    this.data = null

    this.$emit('cancel')
  }

  async submit () {
    if (this.data === null || !this.isValid) {
      return
    }

    try {
      const item = await this.modalState.handle(
        this.createItem(this.data)
      )

      this.$router.push({
        name: 'ItemDetails',
        params: {
          itemGroupId: this.itemGroupId.toString(),
          itemId: item.id.toString()
        }
      })
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível criar novo produto.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  submitAndClose () {
    this.modalState.isActive = false
    this.submit()
  }
}
